import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { useAsync } from '@src/redux/hooks/useAsync';
import { updateTerms, validateTerms } from './actions';
import { VALIDATE_TERMS, UPDATE_TERMS } from './constants';

const tindraftSelector = (state) => {
  return state;
};

export const useTermsOfUse = {
  state: () => {
    return useSelect(tindraftSelector);
  },
  actions: () => {
    return {
      updateTerms: useAction(updateTerms, {
        saga: useAsync(UPDATE_TERMS),
      }),
      validateTerms: useAction(validateTerms, {
        saga: useAsync(VALIDATE_TERMS),
      }),
    };
  },
};
